

interface Props {
    siteKey: string;
    callbackName: string;
    errorCallbackName: string;
}

const RecaptchComponent: React.FC<Props> = ({ callbackName, errorCallbackName, siteKey }) => {

    return <div className="g-recaptcha" style={{ display: "none" }}
        data-sitekey={siteKey}
        data-callback={callbackName}
        data-size="invisible"
        data-error-callback={errorCallbackName}>
    </div>
}

export default RecaptchComponent;